import { Box, Typography } from '@dtx-company/design-system/src'
import { styled } from '@mui/material'
import { useIsRecaptchaEnabled } from '../../../hooks/useIsRecaptchaEnabled'
import React from 'react'

const Wrapper = styled(Box)<{ textAlign?: string }>`
  text-align: ${({ textAlign }) => (textAlign ? textAlign : 'unset')};
  a {
    text-decoration: underline;
  }
`
/**
 * Recaptcha Privacy policy and Terms of Service copy.
 * Only renders if recaptcha and frontegg feature flags are enabled
 *
 * See. https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge.-what-is-allowed
 */
export const RecaptchaPPAndToS = ({ textAlign }: { textAlign?: string }): JSX.Element | null => {
  const isRecaptchaEnabled = useIsRecaptchaEnabled()

  if (isRecaptchaEnabled)
    return (
      <Wrapper textAlign={textAlign}>
        <Typography variant="labelSmall" color="onSurface.secondary">
          This site is protected by reCAPTCHA and the Google{' '}
          <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
          <a href="https://policies.google.com/terms">Terms of Service</a> apply.
        </Typography>
      </Wrapper>
    )

  return null
}
